import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import {
	fetchFormulaListFail,
	fetchFormulaListSuccess,
	fetchFormulaUsage,
	fetchFormulaUsageSuccess,
	initFormulaList,
	refreshFormulaList,
} from './formula.actions';
import { FormulaState } from './formula.state';

export const formulaReducer = createReducer<FormulaState>(
	new FormulaState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(fetchFormulaUsage, initFormulaList, refreshFormulaList, (state) =>
		state.setLoading(true)
	),
	on(fetchFormulaUsageSuccess, (state, action) =>
		state
			.setLoading(false)
			.setFormulaUsages(action.elements)
			.selAllUsageCount(action.allUsageCount)
	),
	on(fetchFormulaListFail, (state) => state.setLoading(false)),
	on(fetchFormulaListSuccess, (state, action) =>
		state.setLoading(false).setFormulaList(action.formulaList)
	)
);
